import { TEXTS } from '../../core/texts';
import React, { useCallback, useState } from 'react';
import { Typography } from '@mui/material';
import InputWithIcon from '../common/InputWithIcon';
import { useSearchParams } from 'react-router-dom';
import { ButtonWithLoader } from '../common/ButtonWithLoader';
import { theme } from '../../theme';
import { ValidationErrorState } from '../../types/validationErrorState';
import { Validator } from '../../core/Validator';
import { useMutation } from '@tanstack/react-query';
import { ISetPasswordProps } from '../../interfaces/setPasswordProps';
import { AdminAuthService } from '../../services/admin-auth';
import { AxiosErrorResponse } from '../../interfaces/errorResponse';
import { parseAxiosError } from '../../services/axios';
import { useAuthState } from '../../+state/useAuthState';
import { useNotification } from '../../+state/useNotification';

const SetPassword = () => {
  const [validErrors, setValidErrors] = useState<ValidationErrorState>({});
  const [searchParams] = useSearchParams();
  const { setUser } = useAuthState();
  const { openErrorToast } = useNotification();

  const mutation = useMutation({
    mutationFn: (data: ISetPasswordProps) => AdminAuthService.setPassword(data),
    onSuccess: (data) => setUser(data),
    onError: (err: AxiosErrorResponse) => {
      const msg = parseAxiosError(err);
      openErrorToast(msg);
      setValidErrors({ password: msg });
    }
  });

  const submitFormHandler = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const password = (e.target as any).password?.value || '';
    const validationErrors = Validator.validate({ password }, Validator.NAMES.AUTH);
    if (validationErrors) {
      return setValidErrors(validationErrors);
    }
    mutation.mutate({
      password,
      token: searchParams.get('token') as string,
      tokenId: searchParams.get('tokenId') as string
    });
  }, [searchParams, mutation]);

  return (
    <>
      <Typography variant={'h2'}>{TEXTS.SET_PASSWORD}</Typography>
      <form onSubmit={submitFormHandler}>
        <InputWithIcon name={'password'} autoComplete={'new-password'} type={'password'}
                       icon={'lock'} placeholder={TEXTS.PASSWORD} required
                       sx={{ my: 2 }} error={!!validErrors['password']} helperText={validErrors['password']}
        />
        {
          validErrors.password &&
          <Typography sx={{ color: theme.palette.error.main, my: 2 }}>
            {validErrors.password}
          </Typography>
        }
        <ButtonWithLoader type={'submit'} variant={'contained'} loading={mutation.isLoading}>
          {TEXTS.CONFIRM}
        </ButtonWithLoader>
      </form>
    </>
  );
};

export default SetPassword;